import SupportListWrapper from 'core/page/SupportListWrapper'
import { listCompanies } from '../state/actions'
import N from 'utils-support/navigation'
import { ICompany } from '@cbgms/api/modules/company'
import { useSearchByCognitoEmail } from 'app-support/company/hooks/use-search-by-cognito-email'
import { useTranslation } from 'react-i18next'

export const onAdd = () => {
  N.push('/companies/new')
}

export const onEdit = (data: { Company: ICompany }) => {
  N.push(`/companies/edit/${data.Company.UUID}`)
}

export const CompaniesList = () => {
  const { getSearchComponent, apiSearchQuery, hasUsersWithoutCompany } = useSearchByCognitoEmail()
  const { t } = useTranslation()

  return (
    <SupportListWrapper
      scope='companies'
      onAdd={onAdd}
      onEdit={onEdit}
      loadAction={listCompanies}
      translationKey='companies'
      middleMenuItems={getSearchComponent}
      predefinedSearch={apiSearchQuery}
      noDataPlaceholder={hasUsersWithoutCompany ? t('Company.UserWithoutCompanyFound') : undefined}
    />
  )
}

export default CompaniesList
